<script setup lang="ts">
import { AccordionContent, AccordionHeader, AccordionItem, AccordionTrigger } from "reka-ui";

defineProps<{ title: string; value: string }>();
</script>

<template>
  <AccordionItem :value="value" class="overflow-hidden">
    <AccordionHeader class="flex">
      <AccordionTrigger class="group flex flex-1 items-center justify-between gap-4 py-4 text-left">
        <span class="h3 text-primary">{{ title }}</span>
        <span class="i-lucide-chevron-down size-12 shrink-0 text-primary transition-transform group-data-[state=open]:rotate-180" aria-label="Expand / Collapse" />
      </AccordionTrigger>
    </AccordionHeader>
    <AccordionContent class="overflow-hidden pb-8">
      <slot />
    </AccordionContent>
  </AccordionItem>
</template>
